import { Avatar, Dropdown, MenuProps, Modal, Space } from 'antd';
import { HistoryOutlined, InfoCircleOutlined, KeyOutlined, LogoutOutlined, SwapOutlined } from '@ant-design/icons';
import { useAppDispatch, useAppSelector } from 'redux/store';
import { actionLogout } from 'components/Authentication/Login/slice';
import { useNavigate } from 'react-router-dom';
import URL from 'constant/url';
import { useNavigateSearch } from 'hooks/useNavigateSearch';
import { useState } from 'react';
import { selectUserProfile } from 'components/Account/AccountProfileTab/slice';

export default function UserSetting() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const navigateSearch = useNavigateSearch();
  const userProfile = useAppSelector(selectUserProfile);
  const userName = userProfile.get_full_name || userProfile.email || localStorage.getItem('username');

  const handleLogout = () => {
    dispatch(actionLogout());
    localStorage.clear();
    navigate(URL.Login);
  };

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleLogoutConfirm = () => {
    setIsModalOpen(false);
    handleLogout();
  };

  const items: MenuProps['items'] = [
    {
      icon: <InfoCircleOutlined />,
      label: 'Thông tin tài khoản',
      onClick: () => {
        navigateSearch(URL.Account, { type: 'info' });
      },
      key: '1',
    },
    {
      type: 'divider',
    },
    {
      icon: <HistoryOutlined />,
      label: 'Lịch sử giao dịch',
      onClick: () => {
        navigateSearch(URL.History, { type: 'transaction' });
      },
      key: '3',
    },
    {
      type: 'divider',
    },
    {
      icon: <SwapOutlined />,
      label: 'Lịch sử đổi IP',
      onClick: () => {
        navigateSearch(URL.History, { type: 'change-ip' });
      },
      key: '4',
    },
    {
      type: 'divider',
    },
    {
      icon: <KeyOutlined />,
      label: 'Đổi mật khẩu',
      onClick: () => {
        navigateSearch(URL.Account, { type: 'change-password' });
      },
      key: '5',
    },
    {
      type: 'divider',
    },
    {
      icon: <LogoutOutlined />,
      label: 'Đăng xuất',
      onClick: () => {
        setIsModalOpen(true);
      },
      key: '6',
      danger: true,
    },
  ];

  return (
    <>
      <Dropdown menu={{ items }} trigger={['click']} placement="bottom" arrow>
        <a>
          <Space className="mobile:hidden">
            <Avatar style={{ backgroundColor: '#fde3cf', color: '#f56a00' }}>{userName?.charAt(0)}</Avatar>
            <div>
              <div className="font-bold text-[#f56a00] leading-5">{userName}</div>
            </div>
          </Space>
        </a>
      </Dropdown>
      <Dropdown menu={{ items }} trigger={['click']} placement="bottomRight" arrow>
        <a>
          <Avatar className="hidden mobile:block" style={{ backgroundColor: '#fde3cf', color: '#f56a00' }}>
            {userName?.charAt(0)}
          </Avatar>
        </a>
      </Dropdown>
      <Modal
        title="Đăng xuất?"
        open={isModalOpen}
        onOk={handleLogoutConfirm}
        onCancel={() => setIsModalOpen(false)}
        okText="Đăng xuất"
        cancelText="Quay lại"
      >
        <p>Bạn có chắc chắn muốn thoát khỏi phiên đăng nhập này?</p>
      </Modal>
    </>
  );
}
